import React, { useEffect, useState, useRef } from "react";
import "./FilterComponent.css";
import GenreFilter from "./GenreFilter/GenreFilter";
import HdSdFilter from "./HdSdFilter/HdSdFilter";
import LanguageFilter from "./LangauageFilter/LanguageFilter";
import secureLocalStorage from "react-secure-storage";

// import {
//   modifyAllLanguageGenreProps,
//   modifySelectedLanguageGenreProps,
// } from "../../CommonFunctions/ConmmonFunctions";
export default function FilterComponent(props) {
  //variables/constants
  const toggleRef = useRef(null);

  const {
    selectedLanguagesProps,
    allLanguagesProps,
    selectedGenresProps,
    allGenresProps,
    onClickSubmit,
    code,
    filterToggle,
    tag,
    onClickFilter,
    filterTag,
    setCount,
  } = props;

  var isHdProps = props?.selectedHd?.exist;

  useEffect(() => {
    if (isHdProps?.toString() === "false") {
      localStorage.setItem("lastHdValue", isHdProps);
    }
  }, []);

  const executeScroll = () => toggleRef.current.scrollIntoView();

  //state
  const [filters, setFilters] = useState([]);
  const [selctedLanguageFilter, setSelectedLanguageFilters] = useState(
    selectedLanguagesProps
  );
  const [selectedGenreFilter, setSelectedGenreFilter] =
    useState(selectedGenresProps);
  const [isHd, setIsHd] = useState(
    localStorage.getItem("lastHdValue") === undefined
      ? isHdProps
      : localStorage.getItem("lastHdValue") === "true" && isHdProps === true
      ? true
      : false
  );

  const [selectedFilter, setSelectedFilter] = useState(filters[0]?.value);
  const [allLanguages, setAllLanguages] = useState(allLanguagesProps);
  const [allGenres, setAllGenres] = useState(allGenresProps);
  //useEffects

  useEffect(() => {
    extractFilters();
    setCount &&
      setCount(selctedLanguageFilter?.length + selectedGenreFilter?.length);
  }, []);

  //functions
  const handleLanguageChange = (lang) => {
    setRefresh(!refresh);
    //check the selected languages
    //if language is new or status of checked is true the add language and make thge status of language as true
    //else change the stauts of language as false

    if (selctedLanguageFilter?.includes(lang.value) === true) {
      let temp1 = selctedLanguageFilter.filter(
        (oneLang) => oneLang !== lang.value
      );
      setSelectedLanguageFilters(temp1);
    } else {
      let temp2 = selctedLanguageFilter;
      temp2.push(lang.value);
      setSelectedLanguageFilters(temp2);
    }
  };

  const handleGnereChange = (genre) => {
    setRefresh(!refresh);
    //check the selected genre
    //if genre is new or status of checked is true the add genre and make thge status of genre as true
    //else change the stauts of genre as false
    if (selectedGenreFilter.includes(genre.value) === true) {
      let temp3 = selectedGenreFilter.filter(
        (oneGenre) => oneGenre !== genre.value
      );
      setSelectedGenreFilter(temp3);
    } else {
      let temp4 = selectedGenreFilter;
      temp4.push(genre.value);
      setSelectedGenreFilter(temp4);
    }
  };

  const handleIsHd = (data) => {
    localStorage.setItem("lastHdValue", data);
    setIsHd(data);
  };
  //function to handle change in filters type
  const filterChangeFunction = (val) => {
    setSelectedFilter(val);
  };

  //function to uppercase starting letter
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  //function to extract filters from backend data
  const extractFilters = (data = props.filters) => {
    let tempFilters = Object.keys(data);
    let tempArray = [];
    for (let i = 0; i < tempFilters.length; i++) {
      if (tempFilters[i] === "hdOrSd") {
        tempArray.push({
          name: "HD/SD",
          value: tempFilters[i],
        });
      } else {
        tempArray.push({
          name: capitalizeFirstLetter(tempFilters[i]),
          value: tempFilters[i],
        });
      }
    }

    setFilters(tempArray);
    setSelectedFilter(tempArray[0].value);
  };

  const toggleButtonSection = () => {
    if (
      JSON.stringify(selctedLanguageFilter?.sort()) ===
        JSON.stringify(selectedLanguagesProps?.sort()) &&
      JSON.stringify(selectedGenreFilter?.sort()) ===
        JSON.stringify(selectedGenresProps?.sort()) &&
      isHd === isHdProps
    ) {
      return true;
    } else {
      return true;
    }
  };

  const handleClearAllButton = () => {
    setSelectedLanguageFilters([]);
    setSelectedGenreFilter([]);
    setIsHd(false);
  };

  const handleSubmit = () => {
    //  localStorage.removeItem("selectedLanguagesAndGenresTemp");
    const isHdData = isHd;

    var filter = {
      filterResponse: {
        selectedLanguages: selctedLanguageFilter,
        selectedGenre: selectedGenreFilter,
        hdOrSd: { selectedHd: isHdData },
      },
    };

    const dataTobeSent = filter;
    code && localStorage.setItem("filterCode", code);

    onClickSubmit !== undefined
      ? onClickSubmit(
          code,
          JSON.stringify(dataTobeSent),
          filterTag === undefined ? tag : filterTag
        )
      : onClickFilter(
        secureLocalStorage.getItem("specialCode"),
          JSON.stringify(dataTobeSent),
          filterTag === undefined ? tag : filterTag
        );

    onClickSubmit !== undefined
      ? filterToggle(true)
      : console.log("closed by packs and channels");
  };

  const [sum, setSum] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setCount &&
      setCount(selctedLanguageFilter?.length + selectedGenreFilter?.length);
  }, [refresh]);

  return (
    <div
      className="full-container"
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "5px !important",
      }}
    >
      <div className="filterMenu-container">
        <div className="filter-left">
          {filters.map((oneFilter) => (
            <div
              onClick={() => filterChangeFunction(oneFilter.value)}
              className="oneFilterTab "
            >
              {oneFilter.name}
              {oneFilter.value === selectedFilter ? (
                <div className="indicator-filter action-tab"></div>
              ) : null}
            </div>
          ))}
        </div>
        <div className="filter-right">
          {selectedFilter === "language" ? (
            <LanguageFilter
              selectedLanguages={selctedLanguageFilter}
              allLanguages={allLanguages}
              onLangChange={(lang) => handleLanguageChange(lang)}
              scrollOnAction={() => executeScroll()}
            />
          ) : null}
          {selectedFilter === "genre" ? (
            <GenreFilter
              selectedGenres={selectedGenreFilter}
              allGenres={allGenres}
              onGenreChange={(genre) => handleGnereChange(genre)}
              scrollOnAction={() => executeScroll()}
            />
          ) : null}
          {selectedFilter === "hdOrSd" ? (
            <HdSdFilter
              isHd={isHd}
              onHdChangeHD={(data) => {
                handleIsHd(data);
              }}
              scrollOnAction={() => executeScroll()}
            />
          ) : null}
        </div>
      </div>
      {toggleButtonSection() ? (
        <div
          ref={toggleRef}
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            width: "100%",
            height: "5rem",
            borderTop: "1px solid #DEDEDE",
          }}
        >
          <button
            onClick={() => {
              handleClearAllButton();
            }}
            style={{
              width: "30%",
              height: "2.5rem",
              background: "white",
              color: "#E24192",
              border: "none",
              border: "1px solid #E24192",
              borderRadius: "6px",
              // fontFamily: "VoltePlay-Medium",
            }}
            className="action-tab"
          >
            Clear All
          </button>
          <button
            key={refresh}
            onClick={() => {
              handleSubmit();
            }}
            style={{
              width: "45%",
              height: "2.5rem",
              background: "#E24192",
              color: "white",
              border: "1px solid #E24192",
              borderRadius: "6px",
              fontSize: "15px",
              // fontFamily: "VoltePlay-Medium",
              opacity:
                selctedLanguageFilter?.length === 0 &&
                selectedGenreFilter?.length === 0 &&
                isHd === false
                  ? "50%"
                  : "100%",
            }}
            className="action-tab"
            disabled={
              selctedLanguageFilter?.length === 0 &&
              selectedGenreFilter?.length === 0
                ? true
                : false
            }
          >
            {selctedLanguageFilter?.length === 0 &&
            selectedGenreFilter?.length === 0
              ? "Apply Filters"
              : `Apply Filters (${
                  selctedLanguageFilter?.length + selectedGenreFilter?.length
                })`}
          </button>
        </div>
      ) : null}
    </div>
  );
}
